import { Button } from 'react-bootstrap'
import type { FallbackProps } from 'react-error-boundary'

export default function AppCrashFallback({ error }: FallbackProps) {
  const errorMessage = error instanceof Error ? error.message : 'Unexpected error'

  return (
    <div className="d-flex min-vh-100 align-items-center justify-content-center bg-light px-3">
      <div className="d-flex flex-column align-items-center text-center"
           style={{ transform: 'translateY(-56px)' }}>
        <div className="d-flex flex-column align-items-center gap-5">
          <img
            src="/brand.png"
            alt="Samsechoes"
            className="d-block mb-3"
            style={{ maxWidth: '192px', height: 'auto' }}
          />
          <i className="fa-solid fa-triangle-exclamation fa-4x text-danger d-block mb-4" aria-hidden="true" />
        </div>
        <h1 className="h3 mb-3">App crashed</h1>
        <p className="text-muted mb-4">
          Something unexpected happened while rendering this page. Please refresh and try again.
        </p>
        <Button
          className="btn btn-primary"
          onClick={() => window.location.reload()}
        >
          Refresh page
        </Button>
        <p className="small text-muted mt-3 mb-0">{errorMessage}</p>
      </div>
    </div>
  )
}
